import React from 'react';
import styled from 'styled-components';

const SubHeaderContainer = styled.div`
  background: #f2efe9;
  width: 100%;
  padding: 6px 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  @media (max-width: 1150px) {
    justify-content: flex-start;
  }
  @media (max-width: ${({ pageId }) => (pageId === 'questions' ? '899px' : '767px')}) {
    flex-direction: column;
    padding: 10px;
  }
`;

const SubHeaderItem = styled.div`
  margin: 0 20px;
  font-size: 14px;
  & strong {
    font-family: Avenir-Heavy;
  }
  @media (max-width: 1150px) {
    min-width: 220px;
  }
`;

const SUB_HEADER_ITEMS = [
  { label: 'Application Number', key: 'applicationNumber' },
  { label: 'Plan Name', key: 'planName' },
  { label: 'Coverage Amount', key: 'coverageAmount' },
  { label: 'Premium Frequency', key: 'premiumFrequency' },
  { label: 'Base Premium Amount', key: 'premiumAmount' },
];

const CustomSubHeader = ({ pageSubHeader, showSubHeader, pageId, currentBreadcrumb }) => {
  if (!showSubHeader) return null;
  const hideKey =
    currentBreadcrumb?.title === 'ReQuote Screen' ||
    currentBreadcrumb?.title === 'Premium Payment Information';
  return (
    <SubHeaderContainer pageId={ pageId }>
      {SUB_HEADER_ITEMS.map(({ label, key }) => {
        return hideKey === false || key !== 'premiumAmount' ? (
          <SubHeaderItem key={ key }>
            <span>
              <strong>{label}:</strong> {pageSubHeader[key]}
            </span>
          </SubHeaderItem>
        ) : (
          ''
        );
      })}
    </SubHeaderContainer>
  );
};

export default CustomSubHeader;
